// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"886cee64","885":"394e0cb0"}[chunkId] + ".chunk.js";
};